import { jsx as _jsx } from "react/jsx-runtime";
import { DateInput, } from '@bos/ui';
import { useController } from 'react-hook-form';
export const DateField = ({ control, name, registerOptions, ...appDateInputProps }) => {
    const { field, fieldState } = useController({
        control,
        name,
        defaultValue: undefined,
        ...registerOptions,
    });
    const { name: fieldName, value: valueWithUndefined, onBlur, onChange, } = field;
    const castedOnChange = onChange;
    const value = valueWithUndefined ?? '';
    return (_jsx(DateInput, { ...appDateInputProps, name: fieldName, value: value, error: fieldState.error?.message, onDateChange: castedOnChange, onBlur: onBlur }));
};
